import * as types from '../actions/actionTypes'
import { readGuestInfo } from '../libs/auth'

const guestInfo = readGuestInfo()

export const initialState = {
  sentPhone: guestInfo.mobile, // * if sendSMS success, store phone number; else = null
  guestId: guestInfo.memberId, // * SMS confirmed
  memberPhone: null, // * already a member, redirect to login
  confirmError: false,
  sendSMSLocked: false,
  contactName: null,
  contactEmail: null,
}

export default function smsReducer(sms = initialState, action) {
  switch (action.type) {
    case types.SMS_REDIRECT_TO_LOGIN:
      return {
        ...sms,
        memberPhone: action.payload,
      }
    case types.LOGIN_SUCCESS:
      return {
        ...sms,
        memberPhone: null,
      }
    case types.SEND_SMS_SUCCESS:
      return {
        ...sms,
        sentPhone: action.payload,
      }
    case types.SEND_SMS_ERROR:
      return {
        ...sms,
        sentPhone: null,
        confirmError: false,
      }
    case types.SEND_SMS:
    case types.CONFIRM_SMS:
      return sms.confirmError ? { ...sms, confirmError: false } : sms
    case types.CONFIRM_SMS_SUCCESS:
      return {
        ...sms,
        guestId: action.payload.member_id,
        confirmError: false,
      }
    case types.CONFIRM_USER_INFO:
      return {
        ...sms,
        contactName: action.payload.contact_name,
        contactEmail: action.payload.contact_email,
      }
    case types.CONFIRM_SMS_ERROR:
      return {
        ...sms,
        guestId: null,
        confirmError: true,
      }
    case types.LOCK_SEND_SMS:
      return {
        ...sms,
        sendSMSLocked: action.payload,
      }
    case types.LOGOUT_SUCCESS:
      return initialState
    default:
      return sms
  }
}
